/**
 * Dev-only console logger. Silent in production builds.
 * Use for non-critical warnings (failed fetches, geolocation errors, etc.)
 * that help during development but shouldn't clutter production browser consoles.
 */
export const devWarn = (...args) => {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
};
